import axios from 'axios';

const save = (params) => {   
    try{
        const response = axios({
            url:`scheme`,
            method:"POST",
            data:params,
            headers:{
              "Accept-Language": "en-US,en;q=0.8"
            }
          }).then((response)=>{
            return response.data
          })
          return response
    }catch(exception){
        return exception
    }
}

const getList = (query) => {
  const qParams = new URLSearchParams(query).toString();
  let url = "/scheme"
  url = `${url}?${qParams}`
  const response = axios({
    url,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    return response.data
  })
  return response
  
}


const schemeService = {
    save,
    getList
};

export default schemeService;